import jwt from "../../http/requests/auth/jwt/index.js"
// import firebase from 'firebase/app'
// import 'firebase/auth'
import router from '@/router'
import axios from "@/axios.js"

export default {
    loginJWT({ commit }, payload) {
        return new Promise((resolve,reject) => {
        jwt.login(payload.userDetails.email, payload.userDetails.password)
            .then(response => {
                // If there's user data in response
                if(response.data.user) {
                    if(response.data.user.roles && response.data.user.roles.length && response.data.user.roles.includes("admin")) {
                        // Set accessToken
                        localStorage.setItem("accessToken", response.data.token)

                        // Update user details
                        commit('UPDATE_USER_INFO', response.data.user, {root: true})

                        // Set bearer token in axios
                        commit("SET_BEARER", response.data.token)

                        var tokenExpiryHour = response.data.expires_in_minutes;
                        tokenExpiryHour = tokenExpiryHour/60;

                        var tokenExpiryTime = new Date();
                        tokenExpiryTime.setHours(tokenExpiryTime.getHours() + tokenExpiryHour);

                        localStorage.setItem('tokenExpiry', tokenExpiryTime);
                        resolve(response)
                    }
                    else reject({message: "Invalid admin role"})
                }
                else reject({message: "Wrong Email or Password"})
            })
            .catch(error => { 
                reject(error) 
            })
      })
    },
    saveFirebaseToken({ commit }, token) {
        let data = {
            device_token : token,
            platform : "web",
            app_type : "heyway",
        }

        return new Promise((resolve, reject) => {
          axios.post("/api/auth/saveDevice", data)
            .then((response) => {
              resolve(response)
            })
            .catch((error) => { 
              reject(error) 
            })
        });
    },
    logout({ commit }, token) {
        return new Promise((resolve, reject) => {
          axios.post("/api/auth/logout", {device_token : token})
            .then((response) => {
              resolve(response)
            })
            .catch((error) => { 
              reject(error) 
            })
        });
    },
    registerUserJWT({ commit }, payload) {
        const { first_name, last_name, email, password, confirmPassword } = payload.userDetails
        return new Promise((resolve,reject) => {

        // Check confirm password
        if(password !== confirmPassword) {
            reject({message: "Password doesn't match. Please try again."})
        }

        jwt.registerUser(first_name, last_name, email, password)
            .then(response => {
                // Redirect User
                // router.push(router.currentRoute.query.to || '/')

                // Update data in localStorage
                localStorage.setItem("accessToken", response.data.token)

                // Update user details
                commit('UPDATE_USER_INFO', response.data.user, {root: true})

                // Set bearer token in axios
                commit("SET_BEARER", response.data.token)

                var tokenExpiryHour = response.data.expires_in_minutes;
                tokenExpiryHour = tokenExpiryHour/60;
                tokenExpiryHour = localStorage.setItem('userData', tokenExpiryTime)

                var tokenExpiryTime = new Date();
                tokenExpiryTime.setHours(tokenExpiryTime.getHours() + tokenExpiryHour);

                localStorage.setItem('tokenExpiry', tokenExpiryTime);
                
                resolve(response)
            })
            .catch(error => { 
                reject(error.response) 
            })
        })
    },
    updateUserJWT({ commit }, payload) {
        const { first_name, last_name, email} = payload.userDetails
        return new Promise((resolve,reject) => {

        jwt.updateUser(first_name, last_name, email)
          .then(response => {
                // Update user details
                commit('UPDATE_USER_INFO', response.data.user, {root: true})
                resolve(response)
            })
            .catch(error => { reject(error) })
        })
    },
    updateUserPasswordJWT({ commit }, payload) {
        const { old_password, new_password, confirm_new_password} = payload.userDetails
        return new Promise((resolve,reject) => {

        jwt.updateUserPassword(old_password, new_password, confirm_new_password)
          .then(response => {
                resolve(response)
            })
            .catch(error => { reject(error) })
        })
    },
    viewProfile({ commit }) {
        return new Promise((resolve,reject) => {
        jwt.viewProfile()
          .then(response => {
                commit('UPDATE_USER_INFO', response.data.user, {root: true})
                resolve(response)
            })
            .catch(error => { reject(error) })
        })
    },
    fetchAccessToken() {
        return new Promise((resolve) => {
            jwt.refreshToken().then(response => { resolve(response) })
        })
    }
}
